export class Preference {
  preferenceCode: string;
  preferenceDescription: string;
  preferenceSubCode: string;
  active: boolean;
  sortBy: number;
}
